import script from "./MenuListCom.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuListCom.vue?vue&type=script&setup=true&lang=js"

import "./MenuListCom.vue?vue&type=style&index=0&id=838a925c&scoped=true&lang=css"

import exportComponent from "H:\\03_微压氧舱-张赟\\共享氧舱\\share-project-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-838a925c"]])

export default __exports__